import React from "react";
import styles from "./view/PlaydateInviteRecipientView.module.css"; // Reuse same styles
import { DayPartSelection } from "../time/types";
import TimeSelectionDisplayView from "../time/TimeSelectionDisplayView";
import TimeSelectionSelectionHeader from "../time/TimeSelectionSelectionHeader";
import { ResponseType } from "../../gql/types";

interface Props {
    responseStatus: string;
    selectedDates?: DayPartSelection[];
    messageToHost?: string;
}

const PlaydateInviteGuestResponse: React.FC<Props> = ({
    responseStatus,
    selectedDates,
    messageToHost,
}) => {
    let statusStr = ""
    switch (responseStatus) {
        case ResponseType.Accept:
            statusStr = "Accepted";
            break;
        case ResponseType.Reject:
            statusStr = "Rejected";
            break;
    }

    return (
        <div className={styles.responseContainer}>
            <div className={styles.sectionHeader}>Your Previous Response:</div>
            <div className={styles.title}>{statusStr}</div>

            {responseStatus === ResponseType.Accept && <div className={styles.sectionHeader}>
                <TimeSelectionSelectionHeader
                    key="yourSelectionsHeader"
                    header="Your Previous Selections:"
                />
            </div>}
            {responseStatus === ResponseType.Accept && <TimeSelectionDisplayView
                mode="daypart"
                groupByDate={true}
                daypartIconSelected={true}
                selectedDayParts={selectedDates}
            />}
            {messageToHost && (
                <>
                    <div className={styles.sectionHeader}>Message to Host:</div>
                    <div className={styles.notes}>
                        {messageToHost || <em>No message provided</em>}
                    </div>
                </>
            )}
        </div>
    );
};

export default PlaydateInviteGuestResponse;
